import { AdminLayout, useMemoAsync, useTranslation } from "@opendash/core";
import { useNavigate, useParams } from "@opendash/router";
import { AdminToolbar } from "@opendash/ui";
import { Button, Card, QRCode } from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { useEffect } from "react";
import { PrintView, useHideOnPrint } from "../../_shared";
import { GlobalPrintStyle } from "../../_shared/print/components/PrintView";
import { Ticket_QR_Code } from "../../js/parsegenerated";

type Props = {};

export const QRCodePrintPage = observer((props: Props) => {
  const t = useTranslation();
  const nav = useNavigate();
  const { className, toggleIsVisible } = useHideOnPrint();
  const { id } = useParams<string>();
  const object = useMemoAsync(
    () => new Parse.Query(Ticket_QR_Code).get(id),
    [id]
  );

  useEffect(() => {
    toggleIsVisible();
  }, []);

  return (
    <PrintView>
      <GlobalPrintStyle />
      <AdminLayout>
        <div className={className}>
          <AdminToolbar
            title={t("maintenance:ticket.create.qr.print.title")}
            onBackButton={() =>
              nav(
                "/admin/parse/OD3_Maintenance_Ticket_QR_Code?hideSourcePicker=true"
              )
            }
            actions={
              <Button onClick={() => window.print()}>
                {t("maintenance:ticket.create.qr.print.btn")}
              </Button>
            }
          />
        </div>
        {object && (
          <Card
            variant="borderless"
            title={object.get("name")}
            styles={{
              title: {
                textAlign: "center",
                border: "none",
                boxShadow: "none",
                background: "none",
                fontSize: "calc(16px + 1vw)",
              },
              body: { border: "none", boxShadow: "none", background: "none" },
            }}
            style={{
              border: "none",
              boxShadow: "none",
              background: "none",
            }}
          >
            <QRCode
              value={object.id}
              style={{
                width: "50%",
                height: "auto",
                border: "none",
                margin: "0 auto",
              }}
            />
          </Card>
        )}
      </AdminLayout>
    </PrintView>
  );
});
